export function isValidIPv4(ip: string) {
	const blocks = ip.split('.');
	if (blocks.length !== 4) {
		return false;
	}

	for (const block of blocks) {
		const numericBlock = parseInt(block, 10);
		if (!(numericBlock >= 0 && numericBlock <= 255)) {
			return false;
		}
	}
	return true;
}

export function isValidIPv6(ip: string) {
	const blocks = ip.split(':');
	if (blocks.length < 8) {
		return false;
	}
	for (const block of blocks) {
		if (!/^[0-9A-Fa-f]{1,4}$/.test(block)) {
			return false;
		}
	}
	return true;
}

export function isValidIP(ip: string | null | undefined): ip is string {
	if (!ip) return false;

	return isValidIPv4(ip) || isValidIPv6(ip);
}
